import styled from 'styled-components';
import { breakpoints, css } from '../../styles/theme';
import WallboxSelect from './WallboxSelectTemplate';
import { rem } from 'polished';

export const WallboxSelectStyled = styled(WallboxSelect)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey12};

    &.isClosed {
        .titleWrapper {
            padding: ${rem('20px')} 0 ${rem('20px')} 0;
        }
    }

    &.isOpen {
        padding-bottom: ${rem('20px')};
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem('20px')} 0 0 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                width: ${rem(25)};
                height: ${rem(25)};

                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .desc {
        margin: ${rem(20)} 0 ${rem(20)} 0;
        line-height: ${rem(18)};
    }

    .link {
        margin-top: ${rem(25)};
        margin-bottom: ${rem(5)};
    }

    .spinner {
        margin: 0 auto ${rem(10)} auto;
        padding: ${rem(20)} 0;
    }
`;
